import React,{useState, useEffect} from 'react'
import { Fade } from "react-slideshow-image";
import "react-slideshow-image/dist/styles.css";
import Button from '@mui/material/Button';
import Axios from 'axios';
import config, { getParameterByName, merchantCode } from "../Configs";
import BackButton from '../components/Back_Button';

export default function Promotion(props) {
  const baseURL = config.baseURL;
  const [promos,setPromos]= useState([{url:'../images/restaurant-bg.jpg'}]);
  const tableNumber = getParameterByName("tableNumber");
   useEffect(()=>{
  async function fetchPromoImgs() {
    // const promosRes= await Axios.get(`${baseURL}/api/promos/?merchantCode=${merchantCode}`);
    //  console.log(promosRes);
    //  if(promosRes.data && promosRes.data.length){
    //  setPromos(promosRes.data);
    //  }
  }
  fetchPromoImgs();
  },[]); 


  return (
    <div style={{ overflow: "hidden !important", height: "auto" }}>
      <iframe style={{width:"100%",height:"100vh"}} src="https://venerable-biscuit-399943.netlify.app/"/>
      <div style={{position:'absolute',zIndex:9999, bottom:"20px", left:"20px" }}>
      <BackButton handleClick={() => props.history.push(`/?` + window.location.href.split('?')[1])} />
      </div>
    </div>
  )
}

